import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const year = new Date().getFullYear();

  const cols = [
    {
      title: "Product",
      links: [
        { to: "/product-detail", label: "Product overview" },
        { to: "/why-choose-us", label: "Why CoursEngage" },
        { to: "/pricing", label: "Pricing" },
        { to: "/sign-up", label: "Get started" },
      ],
    },
    {
      title: "For",
      links: [
        { to: "/sign-up", label: "Instructors" },
        { to: "/sign-up", label: "Students" },
        { to: "/contact", label: "Academic IT" },
        { to: "/contact", label: "Teaching centers" },
      ],
    },
    {
      title: "Company",
      links: [
        { to: "/about", label: "About" },
        { to: "/contact", label: "Contact" },
        { to: "/privacypolicy", label: "Privacy" },
        { to: "/sign-in", label: "Sign in" },
      ],
    },
  ];

  return (
    <footer
      className="mt-24"
      style={{
        backgroundColor: "var(--section-bg)",
        borderTop: "1px solid var(--border-color)",
        color: "var(--text-color)",
      }}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/brand-assets/logo-icon.svg"
                alt=""
                aria-hidden="true"
                width="32"
                height="32"
                className="w-8 h-8 rounded-lg"
              />
              <span className="text-lg font-semibold tracking-tight">CoursEngage</span>
            </Link>
            <p
              className="mt-4 text-sm max-w-xs leading-relaxed"
              style={{ color: "var(--muted-color)" }}
            >
              The modern AI engagement platform for universities. Live polling, Q&amp;A, participation, analytics, and LMS sync all in one place.
            </p>

            <form
              onSubmit={(e) => e.preventDefault()}
              className="mt-6 flex items-center gap-2 max-w-sm"
            >
              <input
                type="email"
                placeholder="you@university.edu"
                aria-label="Email"
                className="text-sm"
              />
              <button className="ce-btn ce-btn-primary text-sm" type="submit">
                Notify me
              </button>
            </form>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h5 className="text-xs font-semibold uppercase tracking-wider mb-4" style={{ color: "var(--muted-color)" }}>
                {col.title}
              </h5>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm transition-colors hover:opacity-100"
                      style={{ color: "var(--text-soft)" }}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="mt-12 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
          style={{ borderTop: "1px solid var(--border-color)" }}
        >
          <p className="text-xs" style={{ color: "var(--subtle-color)" }}>
            © {year} CoursEngage. Built by Debugger Developers.
          </p>
          <div className="flex items-center gap-4 text-xs" style={{ color: "var(--subtle-color)" }}>
            <span className="inline-flex items-center gap-1.5">
              <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "var(--success-color)" }} />
              All systems operational
            </span>
            <Link to="/privacypolicy" style={{ color: "var(--subtle-color)" }}>Privacy</Link>
            <a href="mailto:info@coursengage.com" style={{ color: "var(--subtle-color)" }}>info@coursengage.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
